import { Coord, GridConfig } from "../../../../../../../../../src/types/Interface";
import { LineCoords } from "../types";


export default function getNumberText(GridConfig: GridConfig, lineCoords: LineCoords, coord: Coord): number {
  const unitX = (lineCoords.originCoord.x - coord.x) / GridConfig.cellSize;
  const unitY = (lineCoords.originCoord.y - coord.y) / GridConfig.cellSize;
  return Math.floor(Math.abs(unitX) > Math.abs(unitY) ? -unitX : unitY);
}